import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AdminChangepasswordComponent } from '../admin-changepassword/admin-changepassword.component';

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.scss'],
})
export class AdminFormComponent implements OnInit {
  editForm: any;
  storeForm: any = {};
  role: any = localStorage.getItem('role');
  id: any;
  selectStatus: any;
  imageSrc: string | undefined;
  profileImg: any;
  image: any;
  profileFile: any;
  isShowPaswordField: boolean = true;
  storeData: any;
  showPassword = true;
  
  // location:any = {type:'Point'}
  data = [
    { name: 'Active', status: 1 },
    { name: 'Inactive', status: 0 },
  ];
  roledata = [
    { name: 'Admin', role: 'admin' },
    { name: 'Manager', role: 'manager' },
    { name: 'Chain Manager', role: 'chain_manager' },
    { name: 'Clerk', role: 'clerk' },
    { name: 'Receipt Auditor', role: 'receipt_auditor' },
  ];

  constructor(
    private route: Router,
    public service: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private page: Location,
    private router: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.router.params.subscribe((route) => {
      this.id = route['id'];
    });
  }

  ngOnInit() {
    this.storeForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      role: new FormControl('', Validators.required),
      storeId: new FormControl(),
      assignedStores: new FormControl([]),
      image: new FormControl('',Validators.required),
      systemDownNotifications: new FormControl(false),
      systemDownStores: new FormControl([]),
    });
    if (this.id) {
      this.getAdminById();
    }
    this.getStoreData();
    // console.log(this.storeForm,"local")
  }

  getStoreData() {
    this.service.getRequest(ApiUrl.storeListAdminDropdown).subscribe((res: any) => {
      // console.log(res, "storeData")
      this.storeData = res.response.data?.storesData;
    });
  }
  imgFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.imageSrc = URL.createObjectURL(event.target.files[0]);
    }
  }

  updateImage(event: any, name: any) {
    let files = event.target.files[0];
    // console.log(files, "file")
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.profileImg = e.target.result;
      this.profileFile = files;
    };
    reader.readAsDataURL(files);
  }

  removeImage(name: any) {
    this.profileImg = '';
    this.storeForm.patchValue({
      image: '',
    });
  }

  get buttonTitle() {
    return this.id ? 'Edit Admin' : 'Admin Register';
  }

  getAdminById() {
    this.service
      .getRequest(`${ApiUrl.adminList}/${this.id}`)
      .subscribe((res: any) => {
        if (res.response.success == true) {
          this.isShowPaswordField = false;
          this.profileImg = `${environment.imageUrl}${res.response.data.profileImage}`;
          this.storeForm.patchValue({
            name: res.response.data?.name,
            email: res.response.data?.email,
            password: res.response.data?.password,
            phone: res.response.data?.phone,
            status: res.response.data?.status,
            role: res.response.data?.role,
            storeId: res.response.data?.storeId,
            assignedStores: res.response.data?.assignedStores || [],
            systemDownNotifications: res.response.data?.systemDownNotifications || false,
            systemDownStores: res.response.data?.systemDownStores || [],
          });
          // console.log(this.storeForm, "getstore")
        }
      });
  }

  onSubmit() {
    const selectedRole = this.storeForm.get('role').value;

    if (this.id) {
      const formData = new FormData();
      if (selectedRole === 'clerk') {
        const assignedStores = this.storeForm.value.assignedStores || [];
        assignedStores.forEach((s: any) => formData.append('assignedStores', s));
      } else if (this.storeForm.value.storeId) {
        this.storeForm.value.storeId.map((m: any) => {
          formData.append('storeId', m);
        });
      }
      formData.append('name', this.storeForm.get('name').value);
      formData.append('email', this.storeForm.get('email').value);
      formData.append('password', this.storeForm.get('password').value);
      formData.append('phone', this.storeForm.get('phone').value);
      formData.append('status', this.storeForm.get('status').value);
      formData.append('role', selectedRole);
      formData.append('image', this.profileFile);
      formData.append('systemDownNotifications', this.storeForm.get('systemDownNotifications').value ? 'true' : 'false');
      const systemDownStores = this.storeForm.get('systemDownStores').value || [];
      systemDownStores.forEach((s: any) => formData.append('systemDownStores', s));

      this.service
        .putRequest(`${ApiUrl.adminEdit}/${this.id}`, formData)
        .subscribe((res: any) => {
          this.toastr.success(res.response.message);
          this.route.navigate(['/adminlist']);
        });
    } else {
      this.spinner.show();
      var formData = new FormData();
      if (selectedRole === 'clerk') {
        const assignedStores = this.storeForm.value.assignedStores || [];
        assignedStores.forEach((s: any) => formData.append('assignedStores', s));
      } else if (this.storeForm.value.storeId) {
        this.storeForm.value.storeId.map((m: any) => {
          formData.append('storeId', m);
        });
      }
      formData.append('name', this.storeForm.get('name').value);
      formData.append('email', this.storeForm.get('email').value);
      formData.append('password', this.storeForm.get('password').value);
      formData.append('phone', this.storeForm.get('phone').value);
      formData.append('status', this.storeForm.get('status').value);
      formData.append('role', selectedRole);
      formData.append('image', this.profileFile);
      formData.append('systemDownNotifications', this.storeForm.get('systemDownNotifications').value ? 'true' : 'false');
      const createSystemDownStores = this.storeForm.get('systemDownStores').value || [];
      createSystemDownStores.forEach((s: any) => formData.append('systemDownStores', s));
      if (this.storeForm.valid) {
        this.service.postRequest(ApiUrl.adminRegister, formData).subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.route.navigate(['/adminlist']);
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
      } else {
        this.toastr.error('Please fill required fields');
        this.spinner.hide();
      }
    }

    // console.log(this.storeForm)
  }

  onPhoneInput(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 20);
    this.storeForm.get('phone')?.setValue(input.value);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  openChangePassword() {
    this.dialog.open(AdminChangepasswordComponent, {
      width: '50%',
      data: { id: this.id },
    });
  }

  onBack() {
    this.page.back();
  }
}
